export default {"src":"/_next/static/media/Group-25847.d4f5f544.svg","height":104,"width":104};